import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/shared/AppHeader.css';
import { Icon } from '../../utils/icons';
import { useLang } from '../../i18n';
import { useGeo, CURRENCIES } from '../../geo';

export default function AppHeader() {
  const navigate = useNavigate();
  const { t } = useLang();
  const geo = useGeo();
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const [curOpen, setCurOpen] = useState(false);
  const balanceRef = useRef(null);

  useEffect(() => {
    const sync = () => {
      try { setUser(JSON.parse(localStorage.getItem('user'))); } catch { setUser(null); }
    };
    window.addEventListener('userUpdated', sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener('userUpdated', sync); window.removeEventListener('storage', sync); };
  }, []);

  // Ferme le menu de devises au clic en dehors.
  useEffect(() => {
    if (!curOpen) return;
    const onDoc = (e) => { if (balanceRef.current && !balanceRef.current.contains(e.target)) setCurOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [curOpen]);

  const { symbol, rate } = geo.prices;
  const balance = ((user?.solde_actuel != null ? parseFloat(user.solde_actuel) : 0) * rate).toFixed(2);

  return (
    <div className="appheader">
      <div className="appheader-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img className="appheader-logo-img" src="/logo.png" alt="Roxs Sports" />
      </div>

      <div className="appheader-right">
        {user ? (
          <>
            <div className="balance" ref={balanceRef}>
              <span className="balance-coin">
                <Icon name="coin" w={11} h={11} color="#fff" />
              </span>
              <span className="balance-amount" onClick={() => setCurOpen((o) => !o)} style={{ cursor: 'pointer' }}>{balance} {symbol}</span>
              <span className={'balance-caret' + (curOpen ? ' open' : '')} onClick={() => setCurOpen((o) => !o)} style={{ cursor: 'pointer' }} />
              <span className="balance-plus" onClick={() => navigate('/deposit')} style={{ cursor: 'pointer' }}>+</span>

              {curOpen && (
                <div className="cur-menu">
                  {CURRENCIES.map((c) => (
                    <button
                      key={c.code}
                      className={'cur-item' + (c.code === geo.currency ? ' active' : '')}
                      onClick={() => { geo.setCurrency(c.code); setCurOpen(false); }}
                    >
                      <span className="cur-sym">{c.symbol}</span>
                      <span className="cur-code">{c.code}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div className="appheader-avatar" onClick={() => navigate('/profile/edit')} style={{ cursor: 'pointer' }} />
          </>
        ) : (
          <>
            <button className="appheader-login-btn" onClick={() => navigate('/auth')}>
              {t('auth.login')}
            </button>
            <button className="appheader-register-btn" onClick={() => navigate('/auth?tab=signup')}>
              {t('auth.register')}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
